var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { omitBy } from 'lodash';
import { classToPlain } from 'class-transformer';
import { Collection } from './Collection';
import { $ } from '../../simpli';
import { Helper } from '../../main';
var ResourceCollection = /** @class */ (function (_super) {
    __extends(ResourceCollection, _super);
    function ResourceCollection(classType, items) {
        var _this = _super.call(this, items) || this;
        _this.filters = [];
        _this.classType = classType;
        _this.instance = new classType();
        return _this;
    }
    Object.defineProperty(ResourceCollection.prototype, "params", {
        get: function () {
            var result = {};
            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
                var filter = _a[_i];
                var params = omitBy(classToPlain(filter), function (item) { return item === null; });
                Object.assign(result, params);
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceCollection.prototype, "spinnerName", {
        get: function () {
            return this.instance.$getSpinnerName('query');
        },
        enumerable: true,
        configurable: true
    });
    ResourceCollection.prototype.queryAsArray = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.$action
                            .query(this.params)
                            .name(this.spinnerName)
                            .as(this.items)
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ResourceCollection.prototype.queryAs = function (responseType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.$action
                            .query(this.params)
                            .name(this.spinnerName)
                            .as(responseType)
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ResourceCollection.prototype.addFilter = function (filter) {
        this.filters.push(filter);
        return this;
    };
    ResourceCollection.prototype.clearFilters = function () {
        this.filters = [];
        return this;
    };
    /**
     * @deprecated Use clearFilters instead
     */
    ResourceCollection.prototype.cleanFilters = function () {
        this.filters = [];
        return this;
    };
    ResourceCollection.prototype.headerFrom = function (schemaRef) {
        return this.instance.$headerFrom(schemaRef);
    };
    ResourceCollection.prototype.dataFrom = function (schemaRef) {
        return this.items.map(function (item) { return item.$dataFrom(schemaRef); });
    };
    ResourceCollection.prototype.downloadCsv = function (schemaRef, customTitle) {
        if (schemaRef === void 0) { schemaRef = 'csv'; }
        var schema = this.instance.$getSchema(schemaRef);
        if (schema) {
            schema.downloadCsv(this.all(), customTitle);
        }
    };
    ResourceCollection.prototype.allWithPlaceholder = function (placeholder) {
        if (placeholder === void 0) { placeholder = null; }
        return Helper.allWithPlaceholder(this.items, placeholder);
    };
    ResourceCollection.prototype.getResource = function (id) {
        return Helper.getResource(this.items, id);
    };
    ResourceCollection.prototype.getManyResource = function (ids) {
        return Helper.getManyResource(this.items, ids);
    };
    ResourceCollection.prototype.addResource = function (id, tag, index) {
        Helper.addResource(this.items, Helper.buildResource(id, tag), index);
    };
    ResourceCollection.prototype.removeResource = function (id) {
        Helper.removeResource(this.items, id);
    };
    ResourceCollection.prototype.prependResource = function (id, tag) {
        Helper.prependResource(this.items, Helper.buildResource(id, tag));
        return this;
    };
    ResourceCollection.prototype.prependNullResource = function (tag, useI18n) {
        if (useI18n === void 0) { useI18n = true; }
        return this.prependResource(0, useI18n ? $.t(tag) : tag);
    };
    ResourceCollection.prototype.appendResource = function (id, tag) {
        Helper.appendResource(this.items, Helper.buildResource(id, tag));
        return this;
    };
    ResourceCollection.prototype.onBeforeSerialization = function () {
        this.clear();
    };
    return ResourceCollection;
}(Collection));
export { ResourceCollection };
//# sourceMappingURL=ResourceCollection.js.map